import React, { useState } from "react";
import { Link } from "react-router-dom";
import MusicShell from "../fanHome/MusicShell";
import { isSignedIn } from "../fanHome/fanHomeApi";
import { soundApi } from "../soundDetail/soundApi";
import { ACCENT, Field, PrimaryButton, inputClass, ringStyle } from "../artistStudio/shared";
import { RightsClaimForm } from "./RightsClaimDialog";

// /rights/notice and /rights/dispute (mobile design, screens 38 and 39): the same forms as the Report button on a Sound page, started
// from the Rights & legal hub. The person first says which sound (its link or number), then fills in the form.
export const soundIdFrom = (text) => {
  const value = String(text || "").trim();
  if (/^\d+$/.test(value)) return Number(value);
  const match = value.match(/\/sound\/(\d+)/i);
  return match ? Number(match[1]) : null;
};

export default function RightsFormPage({ kind = "notice" }) {
  const [text, setText] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [sound, setSound] = useState(null);
  const title = kind === "notice" ? "Copyright takedown notice" : "Ownership claim";

  const find = async (event) => {
    event.preventDefault();
    const id = soundIdFrom(text);
    if (!id) { setError("Paste the link of the sound (it ends in /sound/ and a number)."); return; }
    setBusy(true);
    setError("");
    try {
      const detail = await soundApi.detail(id);
      setSound({ id, title: detail?.title || `Sound #${id}` });
    } catch (e) {
      setError("We couldn't find that sound. Check the link and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <MusicShell maxWidth="max-w-2xl">
      <Link to="/rights" className="text-sm font-semibold hover:underline" style={{ color: ACCENT }}>← Rights &amp; legal</Link>
      <h1 className="mt-3 text-2xl md:text-3xl font-bold text-gray-900">{title}</h1>
      {!isSignedIn() ? (
        <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-5" data-testid="rights-login">
          <p className="text-gray-700">Sign in to file this. We need to know who is sending it.</p>
          <Link to="/login" className="mt-4 inline-block rounded-full px-5 py-2.5 font-semibold text-white" style={{ backgroundColor: ACCENT }}>Log in</Link>
          {kind === "notice" && <p className="mt-4 text-sm text-gray-600">No account? <Link to="/rights/takedown" className="font-semibold hover:underline" style={{ color: ACCENT }}>Send the notice without signing in.</Link></p>}
        </div>
      ) : !sound ? (
        <form onSubmit={find} className="mt-6 rounded-2xl border border-gray-200 bg-white p-5" data-testid="rights-find">
          <Field label={kind === "notice" ? "Link to the infringing sound" : "Link to the sound you claim"} required error={error}>
            <input value={text} onChange={(e) => setText(e.target.value)} placeholder="https://…/sound/123" className={inputClass(!!error)} style={ringStyle} aria-label="Sound link" />
          </Field>
          <PrimaryButton type="submit" disabled={busy || !text.trim()} className="mt-4 w-full !py-3">{busy ? "Looking…" : "Continue"}</PrimaryButton>
        </form>
      ) : (
        <div className="mt-6 rounded-2xl border border-gray-200 bg-white p-5">
          <RightsClaimForm sound={sound} kind={kind} onClose={() => setSound(null)} onBack={() => setSound(null)} />
        </div>
      )}
    </MusicShell>
  );
}
